import React from "react";
import ServiceCard from "../ServiceCard/ServiceCard";
import { t } from "../../i18n";
import AnimatedSection from "../AnimatedSection/AnimatedSection";

const services = [
  {
    title: t("services.title1"),
    description: t("services.description1"),
    statValue: 25000,
    statText: t("services.statText1"),
    icon: "/icons/icon1.svg", // SVG yolu
    text: [t("services.text1"), t("services.text2"), t("services.text3")],
    gradient: "from-[#58e0df] via-primaryGreen to-primaryGreen",
    iconColor: "text-primaryGreen",
  },
  {
    title: t("services.title2"),
    description: t("services.description2"),
    statValue: 3,
    statText: t("services.statText2"),
    icon: "/icons/icon2.svg", // SVG yolu
    text: [t("services.text4"), t("services.text5"), t("services.text6")],
    gradient: "from-primaryPurple-light via-primaryPurple to-primaryPurple",
    iconColor: "text-primaryPurple",
  },
  {
    title: t("services.title3"),
    description: t("services.description3"),
    statValue: 21,
    statText: t("services.statText3"),
    icon: "/icons/icon3.svg", // SVG yolu
    text: [t("services.text7"), t("services.text8"), t("services.text9")],
    gradient: "from-[#7ac5e6] via-[#42acdb] to-[#42acdb]",
    iconColor: "text-[#58b3db]",
  },
];

const ServicesSection: React.FC = () => {
  return (
    <section className="w-full py-16 px-4 sm:px-6 scroll-mt-[80px]" id="solutions">
      <div className="max-w-7xl mx-auto">
        <AnimatedSection>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-medium text-gray-900 mb-10 tracking-wide text-center">{t("services.title4")}</h2>
          <h3 className="text-center text-gray-600 mb-10 text-2xl">{t("services.subtitle2")}</h3>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map(({ title, description, icon, statValue, statText, text, gradient, iconColor }, index) => (
            <AnimatedSection key={title} delay={index * 200}>
              <ServiceCard title={title} description={description} icon={icon} statValue={statValue} statText={statText} text={text} gradient={gradient} iconColor={iconColor} />
            </AnimatedSection>
          ))}
        </div>

        {/* Demo Butonu */}
        <AnimatedSection delay={600}>
          <div className="text-center mt-10">
            <button
              onClick={() => {
                const contactElement = document.getElementById("contact");
                if (contactElement) {
                  const headerOffset = 80;
                  const elementPosition = contactElement.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                  window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                  });
                }
              }}
              className="relative overflow-hidden px-6 py-3 text-sm uppercase font-semibold tracking-wide text-white bg-primaryGreen rounded-xl cursor-pointer"
            >
              {t("services.demoButton")}
              <span className="absolute top-0 left-0 w-full h-full bg-white opacity-0 transition-opacity duration-300 ease-in-out" style={{ transformOrigin: "left" }}></span>
            </button>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default ServicesSection;
